/**
 * Domain icon/badge for Riftbound domains.
 * Uses official domain icon images from Riot CDN (see domainIcons.js; source: .tmp/bin/Icons.html).
 * Falls back to coloured badge + symbol for Colourless (no asset).
 */

import { getDomainIconUrl } from './domainIcons.js';

const DOMAIN_SYMBOLS = {
  fury: '◆',
  calm: '◇',
  body: '▲',
  mind: '★',
  order: '●',
  chaos: '✧',
  colourless: '○',
  colorless: '○'
};

export function getDomainId(domain) {
  if (!domain) return 'colourless';
  const label = typeof domain === 'string' ? domain : (domain.label || domain.id || domain);
  return String(label).toLowerCase().replace(/\s/g, '');
}

function DomainBadgeContent({ domain, size = 'default', useImage = true }) {
  const id = getDomainId(domain);
  const safeId = id === 'colorless' ? 'colourless' : id;
  const iconUrl = getDomainIconUrl(safeId);
  const title = typeof domain === 'string' ? domain : (domain?.label || domain?.id || '');
  if (useImage && iconUrl) {
    return (
      <img
        src={iconUrl}
        alt=""
        className="domain-icon-img"
        width={size === 'large' ? 24 : 16}
        height={size === 'large' ? 24 : 16}
        title={title}
      />
    );
  }
  const symbol = DOMAIN_SYMBOLS[safeId] ?? DOMAIN_SYMBOLS.colourless;
  return <span className="domain-icon-symbol">{symbol}</span>;
}

export function DomainBadge({ domain, size = 'default' }) {
  const id = getDomainId(domain);
  const safeId = id === 'colorless' ? 'colourless' : id;
  const title = typeof domain === 'string' ? domain : (domain?.label || domain?.id || '');
  return (
    <span
      className={`domain-badge domain-${safeId} domain-badge-${size}`}
      title={title}
    >
      <DomainBadgeContent domain={domain} size={size} />
    </span>
  );
}

export function DomainBadges({ domains }) {
  if (!domains?.length) {
    return (
      <span className="domain-badge domain-colourless domain-badge-default">
        <span className="domain-icon-symbol">○</span>
      </span>
    );
  }
  const list = Array.isArray(domains) ? domains : [domains];
  return (
    <span className="card-domains">
      {list.map((d, i) => {
        const id = getDomainId(d);
        const safeId = id === 'colorless' ? 'colourless' : id;
        const title = typeof d === 'string' ? d : (d?.label || d?.id || '');
        return (
          <span
            key={i}
            className={`domain-badge domain-${safeId}`}
            title={title}
          >
            <DomainBadgeContent domain={d} />
          </span>
        );
      })}
    </span>
  );
}

export default DomainBadge;
